import {
  STUDIO_WORKSPACE_GROUP_PROPERTY,
  STUDIO_WORKSPACE_GROUP_PROPERTY_VALUE,
} from 'src/constants/studioFtux';

/**
 * Workspace group properties for PostHog client `group()` / SSR `getAllFlags`.
 * Studio portals include the cohort trait so flags targeting `studio="true"`
 * evaluate before (or without relying on) async `$groupidentify` ingest.
 */
export const getWorkspacePosthogGroupProperties = (
  portalName: string,
  isStudioUser: boolean,
): Record<string, string> => ({
  name: portalName,
  ...(isStudioUser
    ? {
        [STUDIO_WORKSPACE_GROUP_PROPERTY]:
          STUDIO_WORKSPACE_GROUP_PROPERTY_VALUE,
      }
    : {}),
});

/** Options bag for posthog-node `getAllFlags` workspace evaluation. */
export const getPosthogGetAllFlagsOptions = (
  portalHeader: string,
  isStudioUser: boolean,
): {
  groups: { workspace: string };
  groupProperties?: {
    workspace: Record<string, string>;
  };
} => ({
  groups: { workspace: portalHeader },
  ...(isStudioUser
    ? {
        groupProperties: {
          workspace: {
            [STUDIO_WORKSPACE_GROUP_PROPERTY]:
              STUDIO_WORKSPACE_GROUP_PROPERTY_VALUE,
          },
        },
      }
    : {}),
});

/** Cache key so Studio and Classic evaluations never share a cached result. */
export const getPosthogFlagsCacheKey = (
  portalHeader: string,
  isStudioUser: boolean,
): string => (isStudioUser ? `${portalHeader}:studio` : portalHeader);
